// extracted by mini-css-extract-plugin
export default {"headerStyleDark":"AppHeader_headerStyleDark__kT0rD","logo":"AppHeader_logo__SgGpb","logoAirforce":"AppHeader_logoAirforce__7y4Am"};